"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerListenerFn = void 0;
require("setimmediate");
var engine_utils_1 = require("@verified/c11-engine.utils");
var getNode_1 = __importDefault(require("./getNode"));
var err_1 = __importDefault(require("./err"));
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
var isArray_1 = __importDefault(require("lodash/isArray"));
function callNode(db, path, i, patch) {
    if (patch === void 0) { patch = []; }
    var fns = db.updates.fns[path];
    if (!fns || !fns[i]) {
        return;
    }
    var fn = fns[i];
    var val = (0, getNode_1.default)(db, path, patch);
    var replacer = function (key, value) {
        if ((0, isPlainObject_1.default)(value) || (0, isArray_1.default)(value) || value !== Object(value)) {
            return value;
        }
        else if (typeof value === "symbol" || value instanceof Symbol) {
            return value.toString();
        }
        return (0, engine_utils_1.randomId)();
    };
    var cacheTest = JSON.stringify(val, replacer);
    if (db.updates.cache[path][i] !== cacheTest) {
        db.updates.cache[path][i] = cacheTest;
        (function () {
            try {
                fn.call(null, val, patch);
            }
            catch (e) {
                if (e instanceof Error) {
                    (0, err_1.default)(db, "/err/types/on/2", {
                        path: path,
                        error: e.message + " " + e.stack,
                        errObj: e,
                    });
                }
            }
        })();
    }
}
function triggerListener(db, path, patch) {
    if (patch === void 0) { patch = []; }
    var fns = db.updates.fns[path];
    if (!fns) {
        return;
    }
    var ids = Object.keys(fns);
    var len = ids.length;
    var _loop_1 = function (i) {
        setImmediate(function () {
            callNode(db, path, ids[i], patch);
        });
    };
    for (var i = 0; i < len; i += 1) {
        _loop_1(i);
    }
}
function triggerListenerFn(db, path, fnId, patch) {
    setImmediate(function () {
        callNode(db, path, fnId, patch);
    });
}
exports.triggerListenerFn = triggerListenerFn;
exports.default = triggerListener;
//# sourceMappingURL=data:application/json;base64,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